export default __webpack_public_path__ + "static/media/worldLBIcon.f6038008.svg";